export default "__VITE_ASSET__6535cdc4__"